var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container",on:{"click":_vm.change}},[_c('label',{staticClass:"checkbox-label"},[_vm._v(_vm._s(_vm.text))]),_c('label',{staticClass:"checkbox",class:{ checked: _vm.isChecked }})])}
var staticRenderFns = []

export { render, staticRenderFns }